module.exports = __webpack_public_path__ + "public/images/welcome.3da7f4d7564b780ff0f232c7f42b0a46.png";